import { render, staticRenderFns } from "./Treasurer.vue?vue&type=template&id=6ecef628"
import script from "./Treasurer.vue?vue&type=script&lang=js"
export * from "./Treasurer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports